import { ref } from 'vue'
import { convertMillisecondsToHMS } from '@/assets/helpers_legacy'
import { Session } from '@/types/session-interfaces'

export function useOrderForm() {
  const orderFormVisible = ref<boolean>(false),
        sessionTitle = ref<string>(''),
        durationHMS = ref<string>(''),
        durationMilliseconds = ref<string>(''),
        recordingUploadId = ref<string>('');

  const requestNotes = (data: Session) => {
    if (data.uploads && data.uploads.length > 0) {
      // Find the first audio recording upload (mobile or desktop recording)
      const audioUpload = data.uploads.find(upload => 
        upload.type === 'mp-mobile-recording' || upload.type === 'mp-desktop-recording'
      )
      
      if (audioUpload) {
        if (audioUpload.duration) {
          durationHMS.value = convertMillisecondsToHMS(audioUpload.duration)
          durationMilliseconds.value = audioUpload.duration.toString()
        }
        recordingUploadId.value = audioUpload.id
      }
    }
    sessionTitle.value = data.title
    orderFormVisible.value = true
  }

  const setOrderFormVisible = (val: boolean) => {
    orderFormVisible.value = val
  }

  return {
    // state
    orderFormVisible,
    sessionTitle,
    durationHMS,
    durationMilliseconds,
    recordingUploadId,
    // methods
    requestNotes,
    setOrderFormVisible,
  }
}